import {
  Container,
  Typography,
  Divider,
  TextField,
  Box,
  InputAdornment,
} from "@mui/material";
import { H6 } from "components/Typography";
import { useEffect, useState } from "react";
import { useSearchPage, useSnackBar } from "hooks";
import { useRouter } from "next/router";

export const PriceRangeBuild = ({
  onChangePriceRange,
  onHandleClearKeyword,
}) => {
  const { queries } = useSearchPage();
  const router = useRouter();
  const [minPrice, setMinPrice] = useState("");
  const [maxPrice, setMaxPrice] = useState("");
  const snackBar = useSnackBar();

  const { price_range } = router.query;

  useEffect(() => {
    if (price_range && typeof price_range === "string") {
      const [min, max] = price_range.split(",");
      setMinPrice(min || "");
      setMaxPrice(max || "");
    }
  }, [price_range]);

  useEffect(() => {
    if (onHandleClearKeyword) {
      setMinPrice("");
      setMaxPrice("");
    }
  }, [onHandleClearKeyword]);

  const handlePriceChange = (action, event) => {
    const value = event.target.value;
    if (/^[0-9]*$/.test(value)) {
      action === "min" ? setMinPrice(value) : setMaxPrice(value);
    }
  };

  const applyPriceRange = () => {
    if (!minPrice && !maxPrice) {
      onChangePriceRange("");
      return;
    }

    if (minPrice && maxPrice && parseFloat(minPrice) > parseFloat(maxPrice)) {
      snackBar.show({
        severity: "info",
        message: "Min price should not exceed max price.",
      });
      return;
    }

    const priceRangeStr = `${minPrice || 0},${maxPrice || 999999}`;
    onChangePriceRange(priceRangeStr); // Only update the state, not the URL
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      applyPriceRange();
    }
  };

  useEffect(() => {
    if (queries?.price_range) {
      const [min, max] = queries.price_range.split(",");
      setMinPrice(min || "");
      setMaxPrice(max || "");
    }
  }, [queries?.price_range]);

  return (
    <Container sx={{ padding: "0px !important" }}>
      <H6>Price Range</H6>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          mt: 1.5,
        }}
      >
        <TextField
          sx={{ width: "125px" }}
          label="Min"
          value={minPrice}
          onChange={(e) => handlePriceChange("min", e)}
          onKeyDown={handleKeyDown}
          InputProps={{
            startAdornment: <InputAdornment position="start">₱</InputAdornment>,
          }}
        />
        <Typography sx={{ mx: 1 }}>to</Typography>
        <TextField
          sx={{ width: "125px" }}
          label="Max"
          value={maxPrice}
          onChange={(e) => handlePriceChange("max", e)}
          onKeyDown={handleKeyDown}
          InputProps={{
            startAdornment: <InputAdornment position="start">₱</InputAdornment>,
          }}
        />
      </Box>
      <Divider
        sx={{
          margin: "1em 0",
          borderBottom: "1.5px solid rgba(125, 135, 156, 0.2)",
        }}
      />
    </Container>
  );
};
